"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TopicConfigurationList_1 = require("./_TopicConfigurationList");
var _QueueConfigurationList_1 = require("./_QueueConfigurationList");
var _LambdaFunctionConfigurationList_1 = require("./_LambdaFunctionConfigurationList");
exports._NotificationConfiguration = {
    type: "structure",
    required: [],
    members: {
        TopicConfigurations: {
            shape: _TopicConfigurationList_1._TopicConfigurationList,
            locationName: "TopicConfiguration"
        },
        QueueConfigurations: {
            shape: _QueueConfigurationList_1._QueueConfigurationList,
            locationName: "QueueConfiguration"
        },
        LambdaFunctionConfigurations: {
            shape: _LambdaFunctionConfigurationList_1._LambdaFunctionConfigurationList,
            locationName: "CloudFunctionConfiguration"
        }
    }
};
//# sourceMappingURL=_NotificationConfiguration.js.map